import { StarsIcon } from 'src/assets/icons';
import { useCopilotAnswer } from '../hook/useCopilot';
import { Close } from '@poli-ink/react';
import { Input, Icon, Button } from '@polichat/flamboyant';

// css module
import styles from './copilot.module.css';
export function CopilotAnswerComponent({
  isWindow24Open,
}: {
  isWindow24Open: boolean;
}) {
  const {
    isOpen,
    input,
    isLoading,
    error,
    retryRequest,
    setInput,
    handleSendAnswer,
    handleOpen,
    handleClose,
  } = useCopilotAnswer();

  if (isWindow24Open) return null;

  return (
    <>
      {/* botão flutuante */}
      {!isOpen && (
        <div className={styles.floatingBtnStyle} onClick={handleOpen}>
          <span role="img" aria-label="copilot">
            <StarsIcon fill="#fff" width={24} height={24} />
          </span>
        </div>
      )}

      {isOpen && (
        <div className={styles.cardStyle}>
          <div className={styles.cardHeader}>
            <StarsIcon fill="#fff" width={24} height={24} />
            <strong>COPILOT Sugestão de respostas</strong>
            <button onClick={handleClose} className={styles.btnClose}>
              <Close width={12} height={12} />
            </button>
          </div>

          {/* Container de erro */}
          {error && (
            <div className={styles.errorContainer}>
              <Icon
                icon={'poli-icon pi-alert-circle'}
                color="#dc3545"
                size={16}
              />
              <span className={styles.errorMessage}>
                Erro ao gerar sugestão.
              </span>
              <button
                onClick={retryRequest}
                className={styles.retryButton}
                disabled={isLoading}
              >
                <Icon
                  icon={'poli-icon pi-reload'}
                  color="#dc3545"
                  size={14}
                  className={isLoading ? styles.reloadIcon : ''}
                />
                Tentar novamente
              </button>
            </div>
          )}

          <div className={styles.cardBody}>
            <Input
              style={{
                cursor: isLoading ? 'wait' : null,
                resize: 'none',
              }}
              type="textarea"
              name=""
              id="textAreaMessageCopilot"
              value={input}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setInput(e.target.value)
              }
              className={`textAreaMessage f-control ${styles.inputTransition} ${
                isLoading ? styles.inputLoading : ''
              }`}
              placeholder={isLoading ? 'Gerando sugestão de mensagem...' : 'Aa'}
              disabled={isLoading || error}
            />
            <Button
              id="sendMessageButtonCopilot"
              border="border-none"
              color="link"
              onClick={handleSendAnswer}
              title="Enviar"
              disabled={isLoading || error}
            >
              <Icon
                icon={'poli-icon pi-set-fill'}
                color="var(--icon-color-font)"
                size={20}
              />
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
